export const thdStoreInfoSelector = (state) => state.thdStoreInfo;
